// AES-GCM поверх WebCrypto: общий примитив шифров модулей (заметки, файлы заметок).
// IV и AAD выбирает вызывающий шифр; ошибки WebCrypto пробрасываются как есть.

export const GCM_IV_BYTES = 12

export async function encryptGcm(key: CryptoKey, iv: Uint8Array, aad: Uint8Array, bytes: Uint8Array): Promise<Uint8Array> {
  const cipher = await crypto.subtle.encrypt({ name: 'AES-GCM', iv, additionalData: aad }, key, bytes)

  return new Uint8Array(cipher)
}

/** Чужой ключ, другие IV или AAD, испорченный шифротекст — исключение WebCrypto */
export async function decryptGcm(key: CryptoKey, iv: Uint8Array, aad: Uint8Array, cipher: Uint8Array): Promise<Uint8Array> {
  const bytes = await crypto.subtle.decrypt({ name: 'AES-GCM', iv, additionalData: aad }, key, cipher)

  return new Uint8Array(bytes)
}
